import CryptoJS from "crypto-js";

const SECRET = "my-32-char-secret";

export const encryptId = (id) => {
    const cipher = CryptoJS.AES.encrypt(String(id), SECRET).toString();
    return encodeURIComponent(cipher);
};


export const decryptId = (ciphertext) => {
    try {
        // 1. Decode the URI component
        const decodedCiphertext = decodeURIComponent(ciphertext);

        // 2. Decrypt the ciphertext
        const bytes = CryptoJS.AES.decrypt(decodedCiphertext, SECRET);

        // 3. Convert bytes to UTF8 string
        const original = bytes.toString(CryptoJS.enc.Utf8);

        // **CRITICAL: Check if the original string is empty or invalid**
        if (!original) {
            console.error("Decryption failed or resulted in an empty string.");
            return NaN; // Return NaN or handle the error as needed
        }

        // 4. Parse the integer (must be a numeric string)
        const parsedId = parseInt(original, 10);

        // 5. Optionally check if parsing failed
        if (isNaN(parsedId)) {
            console.error("Parsed decrypted value is not a number:", original);
        }

        return parsedId;
    } catch (error) {
        console.error("Error during decryption:", error);
        return NaN; // Return NaN on any unexpected error
    }
};
